module.exports = __webpack_public_path__ + "static/media/profile-personal-data.5b4129ed.svg";